import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ValidationQuestion } from '../validation.model';

@UntilDestroy()
@Component({
  selector: 'lib-aside-validation-item',
  templateUrl: './aside-validation-item.component.html',
  styleUrls: ['./aside-validation-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AsideValidationItemComponent {
  readonly sectionId = input.required<string>();
  readonly question = input.required<ValidationQuestion>();
  readonly goToQuestion = output<{
    questionId: string;
    sectionId: string;
    repeaterId?: number;
  }>();
}
